import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstructionCompaniesListComponent } from './components/construction-companies-list/construction-companies-list.component';
import {ConstructionCompaniesRoutingModule } from './construction-companies-routing.module';
import { ConstructionCompanyDetailComponent } from './components/construction-company-detail/construction-company-detail.component';
import { ConstructionCompanyProjectComponent } from './components/construction-company-project/construction-company-project.component'
import { NgxImageGalleryModule } from 'ngx-image-gallery';
import { AgmCoreModule } from '@agm/core';
import {FormsModule} from '@angular/forms';
import { RegisterConstructionProjectComponent } from './components/register-construction-project/register-construction-project.component';
import { RegisterProyectTypesComponent } from './components/register-proyect-types/register-proyect-types.component';
import { ConstructionCompanyHomeComponent } from './components/construction-company-home/construction-company-home.component';
import { ConstructionProjectHomeComponent } from './components/construction-project-home/construction-project-home.component';
import { AllConstructionProjectsComponent } from './components/all-construction-projects/all-construction-projects.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { RecaptchaModule } from "ng-recaptcha";

@NgModule({
  declarations: [ConstructionCompaniesListComponent, ConstructionCompanyDetailComponent, ConstructionCompanyProjectComponent, RegisterConstructionProjectComponent, RegisterProyectTypesComponent, ConstructionCompanyHomeComponent, ConstructionProjectHomeComponent, AllConstructionProjectsComponent],
  imports: [
    ImageCropperModule,
    CommonModule,
    ConstructionCompaniesRoutingModule,
    NgxImageGalleryModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDwGE_CeEzo4IjbZD_YoQdNBqN1jKachWo',
      libraries: [
        'places'
      ],
      language: 'es',
      region: 'co'
    }),
    FormsModule,
    RecaptchaModule
  ]
})
export class ConstructionCompaniesModule { }
